import React, { useState } from "react";
import { Box, Button, FormControlLabel, Checkbox } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { rsProgress } from "../../RecoilStates";
import { rsAddress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOrders } from "../OrdersPage/UseOrders";
import { Link } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Operation(props) {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const { ConfirmOrder, CancelOrder, Waiting } = UseOrders();
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [sendSMS, setSendSMS] = useState(false);
  const [notCollect, setNotCollect] = useState(false);
  const { isSmall } = useBreakpoints();

  return (
    props.orderDetail.stateID !== 6 && (
      <Box
        sx={{
          display: "flex",
          alignItems: isSmall ? "flex-start" : "center",
          p: 2,
          bgcolor: "#f1f1f19e",
          justifyContent: "space-between",
          flexDirection: isSmall ? "column" : "row",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            gap: 2,
          }}
        >
          {(props.orderDetail.stateID == 2 ||
            props.orderDetail.stateID == 5 ||
            props.orderDetail.stateID == 4) && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Link
                target="_blank"
                to={{
                  pathname: `/orders/orderDetail/addressPrint?oid=${props.orderDetail.id}`,
                }}
              >
                <Button
                  sx={{
                    mr: 2,
                    width: "120px",
                    bgcolor: "#ffb700",
                    "&:hover": {
                      bgcolor: "#ffb700",
                    },
                  }}
                  variant="contained"
                >
                  چاپ آدرس
                </Button>
              </Link>
              <Link
                target="_blank"
                to={{
                  pathname: `/orders/orderDetail/factorPrint?oid=${props.orderDetail.id}`,
                }}
              >
                <Button
                  sx={{
                    width: "120px",
                    mr: 2,
                    bgcolor: "#008cff",
                    "&:hover": {
                      bgcolor: "#008cff",
                    },
                  }}
                  variant="contained"
                >
                  چاپ فاکتور
                </Button>
              </Link>
            </Box>
          )}
          {/* {location.state && location.state.orderFilter == 6 && (
          
          )} */}
          {/* {(props.orderDetail.stateID == 5 ||
            props.orderDetail.stateID == 4 ||
            props.orderDetail.stateID == 1) && ( */}
          <Box>
            {location.state && location.state.orderFilter !== 6 ? (
              <Button
                onClick={() => {
                  var body = { OrderId: props.orderDetail.id, Wait: true };
                  setProgress(true);
                  Waiting(body, (callback) => {
                    navigate(
                      `/orders?state=${
                        location.state ? location.state.orderState : 1
                      }`,
                      {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      }
                    );
                  });
                }}
                sx={{
                  width: "100px",
                  bgcolor: "#6800ffa3",
                  "&:hover": {
                    bgcolor: "#6800ffa3",
                  },
                }}
                variant="contained"
              >
                در انتظار
              </Button>
            ) : (
              <Button
                onClick={() => {
                  var body = { OrderId: props.orderDetail.id, Wait: false };
                  setProgress(true);
                  Waiting(body, (callback) => {
                    navigate(
                      `/orders?state=${
                        location.state ? location.state.orderState : 1
                      }`,
                      {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      }
                    );
                  });
                }}
                sx={{
                  width: "100px",
                  bgcolor: "#6800ffa3",
                  "&:hover": {
                    bgcolor: "#6800ffa3",
                  },
                }}
                variant="contained"
              >
                خروج از انتظار
              </Button>
            )}
          </Box>
          {/* )} */}
          <FormControlLabel
            control={
              <Checkbox
                sx={{ p: 0, ml: 3 }}
                checked={sendSMS}
                onChange={(evt) => {
                  setSendSMS(evt.target.checked);
                }}
              />
            }
            label="اس‌ام‌اس ارسال نشود"
          />
          <FormControlLabel
            control={
              <Checkbox
                sx={{ p: 0, ml: 3 }}
                checked={notCollect}
                onChange={(evt) => {
                  setNotCollect(evt.target.checked);
                }}
              />
            }
            label="جمع آوری نشود"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
          }}
        >
          {(props.orderDetail.stateID == 0 ||
            props.orderDetail.stateID == 3) && (
            <Button
              color="secondary"
              sx={{ mr: 2, width: "100px" }}
              variant="outlined"
              onClick={() => {
                navigate("/ordermodify", {
                  state: { OrderId: props.orderDetail.id },
                  replace: true,
                });
              }}
            >
              ویرایش
            </Button>
          )}
          {(props.orderDetail.stateID == 2 ||
            props.orderDetail.stateID == 5 ||
            props.orderDetail.stateID == 4 ||
            props.orderDetail.stateID == 1) && (
            <Button
              color="error"
              sx={{ mr: 2, width: "100px" }}
              variant="outlined"
              onClick={() => {
                setProgress(true);
                CancelOrder(props.orderDetail.id, () => {
                  navigate(
                    `/orders?state=${
                      location.state ? location.state.orderState : 1
                    }`,
                    {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    }
                  );
                });
              }}
            >
              عدم تایید
            </Button>
          )}
          {(props.orderDetail.stateID == 5 ||
            props.orderDetail.stateID == 4 ||
            props.orderDetail.stateID == 3 ||
            props.orderDetail.stateID == 1) && (
            <Button
              variant="contained"
              sx={{ width: "100px" }}
              onClick={() => {
                setProgress(true);
                var body = {
                  OrderId: props.orderDetail.id,
                  SendSMS: !sendSMS,
                  NotCollect: notCollect,
                };
                ConfirmOrder(body, () => {
                  navigate(
                    `/orders?state=${
                      location.state ? location.state.orderState : 1
                    }`,
                    {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    }
                  );
                });
              }}
            >
              تایید
            </Button>
          )}
        </Box>
      </Box>
    )
  );
}
